<template>
  <v-flex xs12 class="text-xs-left">
    <div v-if="isAdmin">
      <CompetitionForm v-bind:isNew="false" v-bind:id="id" v-bind:obj="item"/>
    </div>

    <v-card>
      <v-img
        :src="item.imageUrl"
        position="top"
        height="200px"
        gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
      >
        <v-container fill-height fluid pa-2>
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
              <span class="headline white--text" v-text="item.name"></span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-img>

      <v-card-title>
        <div>
          <span
            class="grey--text"
          >Running from {{dateFormat(item.startDate)}} till {{dateFormat(item.endDate)}}</span>
          <br>
          <span>{{item.description}}</span>
        </div>
        <v-tooltip top v-if="item.matFiles">
          <template #activator="data">
            <v-btn icon v-on="data.on" v-bind:href="item.matFiles">
              <v-icon>fas fa-download</v-icon>
            </v-btn>
          </template>
          <span>Download Mat Files</span>
        </v-tooltip>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="scores"
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.index + 1  }}</td>
          <td>{{ props.item.displayName }}</td>
          <td>{{ props.item.score }}</td>
          <td>{{ props.item.time }} </td>
        </template>
      </v-data-table>
    </v-card>

    <v-btn :to="{name:'Competitions'}">
      <v-icon>arrow_back</v-icon>Back
    </v-btn>

  </v-flex>
</template>
<script>
import { mapGetters } from "vuex";
import CompetitionForm from "@/components/CompetitionForm";
export default {
  name: "Competition",
  components: {
    CompetitionForm
  },
  data: () => ({
    headers: [
      { text: "Rank", value: "rank", sortable: false },
      { text: "User", value: "displayName", sortable: false },
      { text: "Score", value: "score" },
      { text: "Time", value: "time" }
    ],
    pagination: {
      rowsPerPage: 10
    }
  }),
  created() {
    if (this.competitions == null) {
      this.$router.push("/");
    }
    this.$store.dispatch("competitionScores", this.id);
    if (this.item) {
      this.pagination.descending = !this.item.isAscending
      if (this.item.isAscending) {
        this.pagination.sortBy = "time"
      } else {
        this.pagination.sortBy = "score"
      }
    }
  },
  computed: {
    ...mapGetters(["isAdmin", "competitions"]),
    scores() {
      return this.$store.getters.scoresByCid(this.id)
    },
    id() {
      return this.$route.params.id;
    },
    item() {
      if (this.competitions) {
        return this.competitions[this.id];
      }
      return null
    }
  },
  methods: {
    dateFormat(_date) {
      return new Date(_date).toDateString();
    }
  }
};
</script>
